export default __webpack_public_path__ + "static/media/e-cockpit.b7191914.jpg";